<template>
    <div>
        <div class="section_1 flex-col">
            <img class="image_3" referrerpolicy="no-referrer" src="static/img/mobile/mobile_back.png" />
        </div>
        <div class="group_2 flex-col">
            <div class="group_4 flex-col">
                <div class="image-text_7 flex-col" @click="showIndex()" style="box-sizing: border-box; width: 120px; align-self: center; display: flex; flex-direction: column">
                    <img class="image_2" referrerpolicy="no-referrer" src="static/img/mobile/mobile_logo.svg" />
                    <span class="text-group_1" style="text-align: center;">围术期移动护理</span>
                </div>
                <div class="list_4 flex-col">
                    <div class="list-items_3-0 flex-row">
                        <vfield v-model="user.uid" ref="uid" label="用户名:" placeholder="请输入用户名" />
                    </div>
                    <div class="list-items_3-0 flex-row">
                        <vfield v-model="user.pwd" right-icon="eye-o" ref="pwd" :type="isshowpass ? 'text' : 'password'" label="密码:" @click-right-icon="showPassword" />
                    </div>
                </div>
                <div class="text-wrapper_4 flex-col" :style="activeloginBtn ? 'background-color: #0ED1A4' : 'background-color: #9bdcd3;'">
                    <!-- <mt-button type="primary" size="large" :disabled="!activeloginBtn" @click="submit()">登录</mt-button> -->
                    <vbutton type="primary" :disabled="!activeloginBtn" @click="submit()">登录</vbutton>
                </div>
            </div>
        </div>
        <vpopup v-model="showOperWard" round position="bottom">
            <vpicker show-toolbar :columns="OperWards" @confirm="selectOperWardConfirm" @cancel="cancelOperWard" />
        </vpopup>
    </div>
</template>

<script>
import { Picker as vpicker, Popup as vpopup, Button as vbutton, Dialog, Field as vfield } from 'vant'
import 'vant/lib/index.css'
import { mapGetters } from 'vuex'
import { MessageBox } from 'mint-ui'
import JSEncrypt from 'jsencrypt/bin/jsencrypt.min'
import axios from 'axios'
export default {
    name: `TLogin`,
    components: { vpicker, vpopup, vbutton, Dialog, vfield },
    data() {
        return {
            user: {
                uid: ``,
                pwd: ``,
                exp: 100000
            },
            isshowpass: false,
            showOperWard: false,
            OperWards: []
        }
    },
    mounted() {
        this.$nextTick(() => {
            document.documentElement.style.fontSize = `37px`
        })
    },
    methods: {
        // 移动端壳设置首页
        showIndex() {
            MessageBox.prompt(`设置首页`)
                .then(({ value, action }) => {
                    if (typeof cordova != `undefined`) {
                        // eslint-disable-next-line no-undef
                        var startpage = cordova.require(`cordova-plugin-startpage.StartPagePlugin`)
                        startpage.setStartPageUrl(
                            value,
                            function success() {
                                window.location.href = value
                            },
                            function error() {}
                        )
                    }
                })
                .catch(action => {})
        },
        showPassword() {
            this.isshowpass = !this.isshowpass
        },
        submit() {
            if (_.trim(this.user.uid) == ``) {
                MessageBox.alert(`请输入用户名`, `提示信息`)
                return
            }
            if (_.trim(this.user.pwd) == ``) {
                MessageBox.alert(`请输入密码`, `提示信息`)
                return
            }
            let user = Object.assign({}, this.user)
            if (this.$root.PwdEncryptEnabled && this.$root.PwdEncryptEnabled == `1` && this.$root.RsaPublicKeyLogin) {
                let encryptor = new JSEncrypt()
                encryptor.setPublicKey(this.$root.RsaPublicKeyLogin)
                user.pwd = encryptor.encrypt(user.pwd)
            }
            // Indicator.open(`加载中...`)
            this.myaxios
                .mobile_post(`api/AcisSystem/Authorization/Login`, {
                    user_agent: `chrome`,
                    timestamp: new Date().getTime(),
                    data: user
                })
                .then(this.selectWard)
        },
        selectWard(token) {
            sessionStorage.setItem(`token`, token)
            this.$store.dispatch(`ADD_CURRENTUSER`)
            //  加载所有枚举
            this.getToken()
            this.$store.dispatch(`enums/ADD_ALL_ENUM`)
            this.$store.dispatch(`ADD_WARD_AUTH`).then(data => {})
        },
        getToken() {
            let req = axios.get(`${this.$root.DOCSERVICE_BASE}/Wth/GetAuthToken`, {
                headers: { 'content-type': `application/x-www-form-urlencoded` }
            })
            req.then(res => {
                console.log(`11111111111111111111111`, res)
                if (res != null && res.Status === `SUCCESS`) {
                    sessionStorage.setItem(`doctoken`, res.Content)
                }
            }).catch(err => {
                console.log(err)
            })
        },
        ishasPermission() {
            return new Promise((resolve, reject) => {
                let req = this.myaxios.get(`/api/AcisSystem/Authorization/GetPermissions`) // 获取当前用户的权限
                req.then(permissions => {
                    let perms = _.find(permissions, { no: `transferApp_use` }) != undefined
                    resolve(perms)
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        selectOperWardConfirm(item) {
            this.showOperWard = false
            let selectedWard = {
                label: item.text,
                value: item.value,
                origion: item.value
            }
            this.$store.commit(`SET_ACTIVE_HOSPITAL_WARD`, selectedWard)
            this.$router.push({ path: `/t_transferList` }).catch(err => err)
        },
        cancelOperWard() {
            this.showOperWard = false
            sessionStorage.removeItem(`token`)
        }
    },
    computed: {
        ...mapGetters([`currentUser`, `screenHeight`, `hospital_ward_auth`, `active_hospital_ward`]),
        activeloginBtn() {
            if (this.user.uid != `` && this.user.pwd != ``) {
                return true
            } else {
                return false
            }
        }
    },
    watch: {
        hospital_ward_auth: function(newVlaue, oldValue) {
            if (this.hospital_ward_auth && this.hospital_ward_auth.length == 1) {
                let selectedWard = {
                    label: this.hospital_ward_auth[0].label,
                    value: this.hospital_ward_auth[0].value,
                    origion: this.hospital_ward_auth[0].value
                }
                this.$store.commit(`SET_ACTIVE_HOSPITAL_WARD`, selectedWard)
                this.$router.push({ path: `/t_transferList` }).catch(err => err)
            } else if (this.hospital_ward_auth && this.hospital_ward_auth.length > 1) {
                this.OperWards = _.map(this.hospital_ward_auth, hward => {
                    return { text: hward.label, value: hward.value }
                })
                this.showOperWard = true
            } else {
                MessageBox.alert(`用户没有分配院区`, `提示信息`)
            }
        }
    }
}
</script>
<style>
.el-loading-mask.is-fullscreen .el-loading-spinner:after {
    font-size: 16px;
}
</style>
<style scoped>
@import '../mobile_common.css';
.section_1 {
    background-color: rgba(255, 255, 255, 1);
}
.image_3 {
    width: 100%;
    height: 5.76rem;
}
.group_2 {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-size: 100% 100%;
}

.group_4 {
    padding: 1.067rem 0 5.52rem 0;
}

.image-text_7 {
    width: 100%;
    align-self: center;
}

.image_2 {
    width: 1.494rem;
    height: 1.494rem;
    align-self: center;
}

.text-group_1 {
    overflow-wrap: break-word;
    color: rgba(51, 51, 51, 1);
    font-size: 0.533rem;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    text-align: left;
    white-space: nowrap;
    line-height: 0.96rem;
    margin-top: 0.214rem;
}

.list_4 {
    height: 4.48rem;
    margin-top: 0.747rem;
    align-self: center;
}

.list-items_3-0 {
    background-color: rgba(255, 255, 255, 1);
    width: 100%;
    height: 2rem;
    padding: 0.2rem 0.427rem 0.2rem 0.427rem;
}

.text-wrapper_4 {
    box-sizing: border-box;
    border-radius: 5px;
    align-self: center;
    text-align: center;
    margin-top: 32px;
    display: flex;
    flex-direction: column;
    width: 328px;
}
.mint-cell {
    background-size: 0px !important;
}
.mint-cell /deep/ .mint-cell-wrapper {
    background-size: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Mobile/Transfer/Login.vue